/**
 * @generated SignedSource<<7134a4a32c14aa50b84f70ff38f4afa3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type priceChangeOnMatchCaseNotification_fragment$data = {
  readonly createdDate: any;
  readonly id: string;
  readonly read: boolean;
  readonly searchProfileMatchedCase: {
    readonly baseCase: {
      readonly address: string | null | undefined;
      readonly relationType: {
        readonly relationId: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "priceChangeOnMatchCaseNotification_fragment";
};
export type priceChangeOnMatchCaseNotification_fragment$key = {
  readonly " $data"?: priceChangeOnMatchCaseNotification_fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"priceChangeOnMatchCaseNotification_fragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "priceChangeOnMatchCaseNotification_fragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "read",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SearchProfileMatchedCase",
      "kind": "LinkedField",
      "name": "searchProfileMatchedCase",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "baseCase",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "address",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CaseRelation",
              "kind": "LinkedField",
              "name": "relationType",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "relationId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PriceChangedOnMatchedCaseNotification",
  "abstractKey": null
};

(node as any).hash = "31643c2a2783cc264bfdd039788b4948";

export default node;
